import { render, staticRenderFns } from "./CustomerInvoices.vue?vue&type=template&id=c11575bc&scoped=true"
import script from "./CustomerInvoices.vue?vue&type=script&lang=js"
export * from "./CustomerInvoices.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoices.vue?vue&type=style&index=0&id=c11575bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11575bc",
  null
  
)

export default component.exports